import React, { useEffect, useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { AsideDefault } from "./components/aside/AsideDefault";
import { Footer } from "./components/Footer";
import { HeaderWrapper } from "./components/header/HeaderWrapper";
import { Toolbar } from "./components/toolbar/Toolbar";
import { RightToolbar } from "../partials/layout/RightToolbar";
import { ScrollTop } from "./components/ScrollTop";
import { Content } from "./components/Content";
import { PageDataProvider, MessageContext } from "./core";
import { useLocation } from "react-router-dom";
import {
  DrawerMessenger,
  ActivityDrawer,
  Main,
  InviteUsers,
  UpgradePlan,
} from "../partials";
import { MenuComponent } from "../assets/ts/components";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const PublicMasterLayout = () => {
  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, [location.key]);

  const [messageContent, setmessageContent] = useState({
    show: false,
    type: "success",
    message: "Success",
    breadCrumb: [],
    duration: 3000,
  });
  useEffect(() => {
    setmessageContent({ ...messageContent, breadCrumb: [] });
  }, [location]);

  const [open, setOpen] = React.useState(true);
  const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setmessageContent({ ...messageContent, show: false });
  };

  const value = {
    messageContent,
    setmessageContent,
  };

  return (
    <PageDataProvider>
      <MessageContext.Provider value={value}>
        <div className="d-flex flex-column pt-9">
          <Content>
            <Outlet />
          </Content>
        </div>
        <ScrollTop />

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={messageContent.show}
          autoHideDuration={messageContent.duration}
          onClose={handleClose}
        >
          {messageContent.type === "success" ? (
            <Alert
              onClose={handleClose}
              severity="success"
              sx={{
                width: "100%",
                fontFamily: "inherit",
                textTransform: "capitalize",
              }}
            >
              {messageContent.message}
            </Alert>
          ) : (
            <Alert
              onClose={handleClose}
              severity="error"
              sx={{
                width: "100%",
                fontFamily: "inherit",
                textTransform: "capitalize",
              }}
            >
              {messageContent.message}
            </Alert>
          )}
        </Snackbar>
      </MessageContext.Provider>
    </PageDataProvider>
  );
};

export { PublicMasterLayout };
